import { ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client';
import { loader } from 'graphql.macro';
import { logger } from 'logging-utils';
import { GetOrgSbomInut } from '../../applications-types';
import { OrgSbom } from 'common-types';

const query = loader('./export-sbom-to-csv.gql');

const exportSbomOrgToCsv = (client: ApolloClient<NormalizedCacheObject>) => {
  return {
    execute: async (exportSbomToCsvInput: GetOrgSbomInut) => {
      try {
        const results = await client.query<{
          exportSbomToCSV: OrgSbom;
        }>({
          query,
          variables: { exportSbomToCsvInput },
          fetchPolicy: 'no-cache',
        });
        return results.data.exportSbomToCSV;
      } catch (error) {
        logger.error('Failed to fetch org sbom', error);
        return null;
      }
    },
  };
};

export default exportSbomOrgToCsv;
